import Marquee from "react-fast-marquee";
import { useLang } from "../context/LanguageContext";

export const DestinationMarquee = () => {
  const { t } = useLang();
  return (
    <section
      className="relative border-y border-white/10 bg-[#0a0a0a] py-10 md:py-14 overflow-hidden"
      data-testid="marquee-section"
    >
      <Marquee speed={45} gradient gradientColor="#0a0a0a" gradientWidth={120}>
        {t.marquee.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-serif uppercase tracking-widest text-3xl md:text-5xl text-white/85 px-12 md:px-20">
              {item}
            </span>
            <span className="text-[#d4af37] text-2xl md:text-4xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
